import { render, staticRenderFns } from "./form_new_main.vue?vue&type=template&id=3a894866&"
import script from "./form_new_main.vue?vue&type=script&lang=js&"
export * from "./form_new_main.vue?vue&type=script&lang=js&"
import style0 from "./form_new_main.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCheckbox,VForm,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a894866')) {
      api.createRecord('3a894866', component.options)
    } else {
      api.reload('3a894866', component.options)
    }
    module.hot.accept("./form_new_main.vue?vue&type=template&id=3a894866&", function () {
      api.rerender('3a894866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/form_new_main.vue"
export default component.exports